import { ProIp } from "./ApiURL";


// Post Mapping :id  institute id

export const visitorCountGetDataAPI = ProIp + "visitorCount/getData/";